import axios from 'axios';
import { API_URL } from '../constants/url';
import { TPostCreateLeadRequest } from '../types/request/lead';
import { TPostCreateOrganizationRequest } from '../types/request/organization';
import { TPostCreatePersonRequest } from '../types/request/person';

const usePipedrive = () => {
  const createPerson = async (payload: TPostCreatePersonRequest) => {
    const { firstName, lastName, email, phoneNumber } = payload;
    try {
      const result = await axios.post(
        `${API_URL}/person`,
        {
          firstName: firstName,
          lastName: lastName,
          email: email,
          phone: phoneNumber,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      return result.data.data;
    } catch (error) {
      console.error(error);
    }
  };

  const createOrganization = async (
    payload: TPostCreateOrganizationRequest
  ) => {
    const { name, address } = payload;

    try {
      const result = await axios.post(
        `${API_URL}/organization`,
        {
          name: name,
          address: address,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return result.data.data;
    } catch (error) {
      console.error(error);
    }
  };

  const createLead = async (payload: TPostCreateLeadRequest) => {
    try {
      const result = await axios.post(`${API_URL}/lead`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return result.data.data;
    } catch (error) {
      console.error(error);
    }
  };

  return {
    createPerson,
    createOrganization,
    createLead,
  };
};

export default usePipedrive;
